import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24}>
      <title>{'\u5B8C\u6210\u5907\u4EFD 5'}</title>
      <g fill="none" fillRule="evenodd">
        <path
          d="M1 12a11 11 0 1 0 22 0c0-6.075-4.925-11-11-11S1 5.925 1 12Z"
          fill="#0152D9"
        />
        <g>
          <path d="M9 14a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1Z" />
          <path d="M10 15a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1Z" />
        </g>
      </g>
    </svg>
  )
}
const ProcessIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
ProcessIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#FFFFFF',
}
// 参数类型
ProcessIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default ProcessIcon
